import clsx from 'clsx'
import {useFormik} from 'formik'
import React, {useEffect, useState} from 'react'
import {Link, useHistory} from 'react-router-dom'
import * as Yup from 'yup'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import {message} from 'antd'
import Select from 'react-select'
import loc from '../data/Location.json'
import { AddWebsiteLeftBreadcrum } from './AddWebsiteLeftBreadcrumb'
import { toAbsoluteUrl } from '../../_metronic/helpers'


export function AddWebsiteComplete() {
  const history: any = useHistory()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [tags, setTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const [searchedTags, setSearchedTags] = useState([])

  // const formik = useFormik({
  //   initialValues: initialValues,
  //   validationSchema: registrationSchema,
  //   enableReinitialize: true,
  //   onSubmit: (values, {setStatus, setSubmitting}) => {
  //     console.log("idhar");
      
  //     setLoading(true)
  //     setTimeout(() => {
  //       try {
  //         // let request: any = values;
  //         // request.agencyAssociated = agencyAssociated;
  //         setLoading(false)
  //         setSubmitting(false)
  //         history.push({
  //           pathname: '/agencyDetails',
  //           state: {
  //             ...history.location.state,
  //             ...{companyDetails: values},
  //           },
  //         })
  //       } catch {
  //         setLoading(false)
  //         setSubmitting(false)
  //         setStatus('Registration process has broken')
  //         // Remove logs when not needed
  //       }
  //     }, 1000)
  //   },
  // })


//   const checkHandle = (cat)=>{
//     if(!check(cat)){
//       let x= [...selectedTags]
//       x.push({id:cat._id,Name:cat.Name})
//       setSelectedTags(x)
//       setError(false)
//     } else{
//       let x= [...selectedTags]
//       x.forEach((ele,ind)=>{
//         if(ele.id===cat._id){
//           x.splice(ind,1)
//         }
//       })
//       setSelectedTags(x)
//       if(selectedTags.length===1){
//         setError(true)
//       }
//     }
    
//   }

//   const search = (e)=>{
//     setSearchValue(e.target.value)
//   }

//   const deleteTags = (x,ind)=>{
//     let a = [...selectedTags]
//     a.splice(ind,1)
//     setSelectedTags(a)
//     if(selectedTags.length===1){
//       setError(true)
//     }
//   }

//   // useEffect(()=>{
//   //   let x= []
//   //   for(let i=0;i<tags.length;i++){
//   //     if(tags[i].checked){
//   //       x.push(tags[i])
//   //     }
//   //   }
//   //   setSelectedTags(x)
//   // },[tags])

//   useEffect(()=>{
//     httpService.getData(
//       '/tag-master?search='+searchValue,
//       (res)=>{
//         console.log(res.data.data.data)
//         setTags(res.data.data.data)
//       },
//       (err)=>{
//         message.error("Not able to fetch.")

//       }
//     )
//   },[searchValue])

//   const submitForm = (e)=>{
//     e.preventDefault()
//     setLoading(true)
//     if(selectedTags.length===0){
//       setError(true)
//     }
//     else{
//       setError(false)
//       httpService.patchData(
//       '/website/update/?step=4',
//       {
//         id:history.location.state.id,
//         Tags:selectedTags,
//       },
//       (res)=>{
//         console.log(res);
//         setLoading(false)

//         history.push({
//             pathname: '/addWebsite/associated-pages',
//             state: {
//               ...history.location.state,
//             },
//           })
//       },
//       (err)=>{
//         setLoading(false)

//         console.log(err);
//       }
//     )
//     }
    
//   }

//   const check = (cat)=>{
//     let x= false
//     selectedTags.forEach(c=>{
//       if(c.id===cat._id){
//         x=true
//       }
//     })
//     return x

//   }


//   const [nameError, setNameError] = useState(false)
  // const validateName = (name: any) => {
  //   httpService.getData(
  //     '/' + history.location.state?.type.toLowerCase() + '-master/',
  //     (res: any) => {
  //       if (history.location.state?.type == 'Agency') {
  //         htmlFor (var i = 0; i < res.data.data?.agencies.length; i++) {
  //           if (res.data.data?.agencies[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       } else {
  //         htmlFor (var i = 0; i < res.data.data?.brands.length; i++) {
  //           if (res.data.data?.brands[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       }
  //     },
  //     (err: any) => {}
  //   )
  // }

  return (
    <div className='CompanyDetailsOuter '>
      <AddWebsiteLeftBreadcrum currentStep='7' />
      {/* <div className='CompanyDetails' style={{marginBottom: '100px'}}>
        
      </div> */}
      <div className='CompanyDetails bg-white m-5 p-5 pb-15  rounded h-90'>
        <div style={{width: '100%', height: '367px'}} className='d-flex justify-content-center'>
          <img src={toAbsoluteUrl('/media/logos/Site-constructor.png')}></img>
        </div>
        <div className='d-flex justify-content-center'>
          <h1 className='fw-bolder text-dark ms-5 mt-5'>Wohoo!</h1>
        </div>
        <div className='d-flex justify-content-center'>
          <p style={{fontSize: '14px', textAlign: 'center', width: '75%', marginTop: '15px'}}>
          You have successfully added a new website.
          </p>
        </div>
        <div style={{width: '100%', marginTop: '30px'}} className='d-flex justify-content-center'>
          <Link
            style={{width: '30%', height: '49px'}}
            to={{
              pathname:"/website/view-all",
              state: {type: 'Website'},
            }}
          >
            <button className='btn btn-gray-200 flex w-100 h-100'>
                <b className='fs-6'>Go Home</b>
            </button>
          </Link>
          <div style={{width: '30%', height: '49px'}}>
            <button
              className='btn fw-bolder btn-primary  ms-5 w-100 h-100'
              onClick={()=>{
                history.push("/addWebsite")
              }}
            //   onClick={() => {
            //     httpService.postData(
            //       '/auth/'+ history.location.state?.type.toLowerCase()  + '/set-password',
            //       {email: history.location.state.agencyDetails.email},
            //       (response: any) => {
            //         message.success(
            //           'Access details shared to ' + history.location.state.agencyDetails.email
            //         )
            //         history.push({
            //           pathname:'/master/brands',
            //           state: {
            //             type: history.location.state.type,
            //           },
            //         })
            //       },
            //       (error: any) => {
            //         if (error.message) message.error(error.message)
            //       }
            //     )
            //   }}
            >
              Add Another Website
            </button>
          </div>
        </div>
        {/* <Link
          to="/"
        >
          <div className='link-primary fs-6 fw-bolder mt-10 text-center'>
            Go to  List
          </div>
        </Link> */}
      </div>
      

      {/* <form
        className='CompanyDetails'
        noValidate
        id='kt_login_signup_form'
        onSubmit={submitForm}
        style={{marginBottom: '100px'}}
      >
        <h2 className=''>Website Tags</h2>
        <div className='row pt-4 pe-5 '>
          <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
          {selectedTags.map((x,ind)=>{            
            return(<div className='selectedCategory'>{x.Name}<img style={{paddingLeft:"5px", paddingBottom:"3px", cursor:"pointer"}} onClick={()=>deleteTags(x,ind)} src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')} alt="cross" /></div>)
          })}
          </div>
        </div>
        <div className='row pt-4 pe-5 '>
          <div className='col'>
          <div className="input-group mb-5">
              <span className="input-group-text" style={{border:"none", paddingRight:"5px"}} id="basic-addon1">
                  <span className="svg-icon svg-icon-3x">
                      <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt="search" />
                  </span>
              </span>
              <input type="text" className="form-control form-control-solid rounded-4 bg-white-100" style={{paddingLeft:"2px"}} onChange={search} value={searchValue} placeholder="Search tags"/>
          </div>
          </div>
        </div>
        <div className='row pe-5 pb-5 '>
          <div className='col scrollContainer'>
            {tags.map((cat,ind)=>{
              return (
                <div className="form-check form-check-custom form-check-solid form-check-sm m-4">
                    <input className="form-check-input" type="checkbox" value={cat.Name} id={cat.Name} checked={check(cat)} onClick={()=>checkHandle(cat)}/>
                    <label className="form-check-label" htmlFor={cat.Name}>
                        {cat.Name}
                    </label>
                </div>
              )
            })}
          </div>
        </div>
        
        
        <div className='d-flex pt-4 pe-5'>
          <Link
            to={{
              pathname:
                '/addWebsite/categories',
              state: history.location.state,
            }}
          >
            <button type='button' className='btn fw-bolder btn-gray-200 CompanyDetailButton'>
              Back
            </button>
          </Link>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-primary ms-5 CompanyDetailButton'
            onClick={()=>{
              console.log("kidhar")
              // history.push({
              //   pathname: '/addWebsite/associated-pages',
              //   state: {
              //     ...history.location.state,
              //   },
              // })
            }}
            disabled={loading}
            // disabled={
            //   formik.isSubmitting ||
            //   !formik.isValid ||
            //   nameError ||
            //   !checkGST(formik.values.gstNumber)
            // }
          >
            {!loading && <span className='indicator-label'>Next</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
            {/* <span className='indicator-label'>Next</span> */}
          {/* </button>
        </div>
        {error && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span className='text-danger' role='alert'>
                    Select atleast 1 tag.
                  </span>
                </div>
              </div>
            )}
      

      </form> */} 
      
    </div>
  )
}
